import { Skeleton } from "@/app/components/shadcn/skeleton";

const FilterSkeleton = () => (
  <div className="space-y-3 p-2">
    {Array.from({ length: 6 }).map((_, i) => (
      <Skeleton key={i} className="h-10 w-full" />
    ))}
  </div>
);

export default FilterSkeleton;
